import React, { useState } from 'react'
import './top.css';
import man from '../../assets/man.png';

import {IoMdDownload} from "react-icons/io"
const Top = () => {
  const [activeNav, setActiveNav] = useState('#home');
  return (
    <div className='top'>
      <div className='topbar'>
            <div className='logo' style={{marginRight:"100px"}}>
               {/* <p id='logo'>Vivek.N</p> */}
               <a href='/' id='logo'>Vivek.N</a>

                 </div>
            <div className='navbar' style={{display:"flex",width:"100%",justifyContent:"space-evenly"}}>
                <a href='#home' onClick={()=> setActiveNav('#home')} className={activeNav === '#home' ? 'active' : ''}>Home</a>
                <a href='#about' onClick={()=> setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}>About</a>
                <a href='#experience' onClick={()=> setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''}>Skills</a>
                <a href='#portfolio' onClick={()=> setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active' : ''}>Projects</a>
                <a href='#contact' onClick={()=> setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''}>Contact </a>
                <a 
                  href="./Vivek_Nemade v3.pdf"
                  target="_blank" 
                  download
                  style={{alignItems:"center"}} >
                   <span style={{paddingRight:"7px"}}>My CV</span>  <IoMdDownload size={20}/>
                  </a>
            </div>
             
        </div>
        </div>
  )
}

export default Top